import { injectable } from 'inversify';
import env from '@framework/env/env';

export interface IDomainConfig {
  scheme: string,
  protocol: string,
  finsightDomain: string,
  apiDomain: string,
  usersDomain: string,
  dealroadshowDomain: string,
  managerDomain: string,
  condorDomain: string,
  openmarketDomain: string,
  assetsDomain: string,
  allocateDomain: string,
  evercallDomain: string,
  corsDomains: string,
  creditflowresearchDomain: string,
}

@injectable()
export class DomainConfig implements IDomainConfig {
  scheme: string;

  protocol: string;

  finsightDomain: string;

  apiDomain: string;

  usersDomain: string;

  dealroadshowDomain: string;

  managerDomain: string;

  condorDomain: string;

  openmarketDomain: string;

  assetsDomain: string;

  allocateDomain: string;

  evercallDomain: string;

  corsDomains: string;

  creditflowresearchDomain: string;

  constructor() {
    this.scheme = env('DOMAIN_SCHEME');
    this.protocol = `${ this.scheme } :`;
    this.finsightDomain = env('FINSIGHT_DOMAIN');
    this.apiDomain = env('API_DOMAIN');
    this.usersDomain = env('USERS_DOMAIN');
    this.dealroadshowDomain = env('DEALROADSHOW_DOMAIN');
    this.managerDomain = env('MANAGER_DOMAIN');
    this.condorDomain = env('CONDOR_DOMAIN');
    this.openmarketDomain = env('OPENMARKET_DOMAIN');
    this.assetsDomain = env('ASSETS_DOMAIN');
    this.allocateDomain = env('ALLOCATE_DOMAIN');
    this.evercallDomain = env('EVERCALL_DOMAIN');
    this.corsDomains = env('CORS_DOMAINS');
    this.creditflowresearchDomain = env('CREDITFLOWRESEARCH_DOMAIN');
  }
}
